import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _CART_SERVICE_ERROR, _CART_SERVICE_SUCCESS;
/**
 * @module cart-constants
 * @ignore
 * __VERSION_HERE__
 */

// NOTE - if you are looking for missing values, please check @nike/ux-tread-dotcom-constants

/**
 * Constants are defined in this module to reference the actions that are invoked on the client
 * as well as in the reducer when updating state
 */

export var CART_STATE_KEY = '@carts';
export var CART_UX_NAMESPACE = 'dotcom-cart';

// url related
export var CARTS_BASE_PATH = 'buy/carts/v2';
export var CHECKOUT_PATH = '/checkout';

// state related consts
export var TOTALS_STATE = {
  quantity: 0,
  total: 0,
  subtotal: 0
};
export var CART_STATE = {
  brand: 'NIKE',
  // we need to reconsider this as a default state value
  channel: 'NIKECOM',
  // we need to reconsider this as a default state value
  country: 'US',
  // we need to reconsider this as a default state value
  currency: 'USD',
  // we need to reconsider this as a default state value
  id: null,
  items: [],
  // NOTE - this should stay as an array per schema
  totals: TOTALS_STATE,
  links: {
    self: {
      ref: ''
    }
  },
  resourceType: 'cart'
};
export var META_STATE = {
  appId: null
};
export var INITIAL_STATE = {
  meta: META_STATE,
  cart: CART_STATE,
  totals: TOTALS_STATE,
  locale: {},
  inFlight: [],
  errors: [],
  itemIds: []
};

// VAS related
export var FULL_CUSTOMIZATION = 'customization/nike_id';
export var JERSEY_ID = 'customization/jersey_id';
export var WARRANTY = 'buy/warranty';
export var FULL_CUSTOMIZATION_IDENTIFIER = 'FULL_CUSTOMIZATION';
export var WARRANTY_IDENTIFIER = 'WARRANTY';
export var VAS_INSTRUCTION_TYPE_MAP = {
  FULL_CUSTOMIZATION: FULL_CUSTOMIZATION,
  JERSEY_ID: JERSEY_ID,
  WARRANTY: WARRANTY
};

// Gift card related
export var DIGITAL_GIFTCARD = 'DIGITAL_GIFTCARD';
export var MAX_QUANTITY = 10;

// cart calls
export var SERVICE_ATC_CARTS = 'CARTS/addItemsByParams';
export var SERVICE_EMPTY_CART = 'CARTS/removeCartsByFilter';
export var SERVICE_FETCH_CART_CARTS = 'CARTS/getCartsByParams';
export var SERVICE_FETCH_CART_ID = 'CARTS/getCartsById';
export var SERVICE_REMOVE_ITEM = 'CARTS/removeItemsByParams';
export var SERVICE_ADD_PROMOTION = 'CARTS/promotions/add';
export var SERVICE_REMOVE_PROMOTION = 'CARTS/promotions/remove';
export var SERVICE_UPDATE_ITEM_QTY = 'CARTS/replaceItemsByParams/quantity';
export var SERVICE_UPDATE_ITEM = 'CARTS/replaceItemsByParams';
export var SERVICE_ADD_VAS_WARRANTY = "".concat(SERVICE_UPDATE_ITEM, "/add/warranty");
export var SERVICE_REMOVE_VAS_WARRANTY = "".concat(SERVICE_UPDATE_ITEM, "/remove/warranty");
export var SERVICE_MERGE_CARTS = 'CARTS/mergeCartsByParams';

// action types
export var ON_INIT_CART = "".concat(CART_STATE_KEY, "/ON_INIT_CART");
export var MISSING_VALUES = "".concat(CART_STATE_KEY, "/MISSING_VALUES");
export var ON_FETCH_START = "".concat(CART_STATE_KEY, "/ON_FETCH_START");
export var ON_FETCH_SUCCESS = "".concat(CART_STATE_KEY, "/ON_FETCH_SUCCESS");
export var ON_FETCH_FAILURE = "".concat(CART_STATE_KEY, "/ON_FETCH_FAILURE");
export var CLEAR_ERRORS = "".concat(CART_STATE_KEY, "/CLEAR_ERRORS");
export var CLEAR_CART_STATE = "".concat(CART_STATE_KEY, "/CLEAR_CART_STATE");
export var NO_LOCAL_STORAGE = "".concat(CART_STATE_KEY, "/NO_LOCAL_STORAGE");

// cart action types
export var ADD_TO_CARTS_SUCCESS = "".concat(CART_STATE_KEY, "/ADD_TO_CARTS_SUCCESS");
export var ADD_TO_CARTS_FAILURE = "".concat(ON_FETCH_FAILURE, "/").concat(SERVICE_ATC_CARTS);
export var MERGE_CARTS_SUCCESS = "".concat(ON_FETCH_SUCCESS, "/").concat(SERVICE_MERGE_CARTS);
export var MERGE_CARTS_FAILURE = "".concat(ON_FETCH_FAILURE, "/").concat(SERVICE_MERGE_CARTS);
export var FETCH_CARTS_SUCCESS = "".concat(ON_FETCH_SUCCESS, "/").concat(SERVICE_FETCH_CART_CARTS);
export var FETCH_CARTS_FAILURE = "".concat(ON_FETCH_FAILURE, "/").concat(SERVICE_FETCH_CART_CARTS);

// map to tell which service should call a specific action type
export var CART_SERVICE_ERROR = (_CART_SERVICE_ERROR = {}, _defineProperty(_CART_SERVICE_ERROR, SERVICE_ATC_CARTS, ADD_TO_CARTS_FAILURE), _defineProperty(_CART_SERVICE_ERROR, SERVICE_FETCH_CART_CARTS, FETCH_CARTS_FAILURE), _defineProperty(_CART_SERVICE_ERROR, SERVICE_MERGE_CARTS, MERGE_CARTS_FAILURE), _CART_SERVICE_ERROR);
export var CART_SERVICE_SUCCESS = (_CART_SERVICE_SUCCESS = {}, _defineProperty(_CART_SERVICE_SUCCESS, SERVICE_MERGE_CARTS, MERGE_CARTS_SUCCESS), _defineProperty(_CART_SERVICE_SUCCESS, SERVICE_FETCH_CART_CARTS, FETCH_CARTS_SUCCESS), _CART_SERVICE_SUCCESS);
export var CRC_ERROR_CODES = {
  CART_NOT_FOUND: 'D3D734B6',
  ITEM_QUANTITY_LIMIT: '963D3D87',
  // OUT_OF_STOCK: '',
  // PRODUCT_NOT_BUYABLE: '',
  PROMOTION_CODE_INVALID: '4CB0532B'
};

/**
 * deprecated
 */
export var ADD_TO_WISHLIST_FROM_CART_START = 'ADD_TO_WISHLIST_FROM_CART_START';
export var ADD_TO_WISHLIST_FROM_CART_SUCCESS = 'ADD_TO_WISHLIST_FROM_CART_SUCCESS';
export var ADD_TO_WISHLIST_FROM_CART_FAILURE = 'ADD_TO_WISHLIST_FROM_CART_FAILURE';